<template>
  <div style="margin-bottom: 20px">
    <v-flex class="pb-4 caption font-weight-bold">
      {{ text.title }}
    </v-flex>

    <v-flex offset-xs2 xs8>
      <v-img :src="qrcode" />
      <div class="btn-download" @click="downloadQR">
        {{ text.btn }}
      </div>
    </v-flex>
    <!-- <v-flex class="pb-4 body-1" v-html="text.description" /> -->
  </div>
</template>

<script>
import domtoimage from 'dom-to-image'
export default {
  data() {
    return {
      loading: false
    }
  },
  mounted() {
    if (!this.qrcode) {
      this.loading = true
    } else {
      this.loading = false
    }
  },
  computed: {
    qrcode() {
      if (!this.$store.state.qr) return require('@/assets/no_img.png')
      return this.$store.state.qr
    },

    text() {
      let obj = {}
      if (this.$store.state.language == 'EN') {
        obj = {
          title: 'Scan QR',
          description:
            'Just a moment, plaease do not close or refresh browser <br /> After success, the system will automatically return to home page.',
          btn: 'Save'
        }
      } else {
        obj = {
          title: 'กรุณาสแกนคิวอาร์ เพื่อชำระเงิน',
          description:
            'โปรดรอซักครู่ กรุณาอย่าปิดหน้าบราว์เซอร์ หรือทำการรีเฟรช <br /> หลังชำระเงินแล้ว ระบบจะทำการพาคุณกลับสู่หน้าหลัก',
          btn: 'บันทึก'
        }
      }
      return obj
    }
  },
  methods: {
    downloadQR() {
      const element = document.querySelector('.v-input__append-inner')
      element.style.display = 'none'

      this.loading = true
      domtoimage
        .toJpeg(document.getElementById('screenshot'), {
          quality: 0.95
        })
        .then(dataUrl => {
          var link = document.createElement('a')
          let urlString = window.location.href
          link.download = urlString.split('?')[1].split('=')[1] + '.jpg'
          link.href = dataUrl
          link.click()
          this.loading = false
          element.style.display = 'flex'
        })
    }
  }
}
</script>

<style scoped>
.btn-download {
  background-color: #f5f5f5;
  border: 2px solid #000;
  border-radius: 8px;
  padding: 10px;
  text-align: center;
  cursor: pointer;
  font-size: 20px;
  font-weight: bold;
  margin: 5px;
}
</style>
